import {
	API_GET_ALL_SPECIAL_REGIME,
	API_ADMIN_GET_ALL_SPECIAL_REGIME,
	API_ADMIN_GET_SPECIAL_REGIME,
	ADMIN_INIT_NEW_SPECIAL_REGIME,
	ADMIN_RESET_FOCUS_SPECIAL_REGIME,
	API_ADMIN_POST_SPECIAL_REGIME,
	API_ADMIN_PATCH_SPECIAL_REGIME,
	API_ADMIN_DELETE_SPECIAL_REGIME
} from 'actions/specialRegime';

export function getAllSpecialRegimes() {
	return {
		type: API_GET_ALL_SPECIAL_REGIME,
		payload: {
			request: {
				url: `/specialRegimes`
			}
		}
	};
}

export function adminGetAllSpecialRegimes() {
	return {
		type: API_ADMIN_GET_ALL_SPECIAL_REGIME,
		payload: {
			request: {
				url: `/admin/specialRegimes`
			}
		}
	};
}

export function adminGetSpecialRegime(specialRegime) {
	return {
		type: API_ADMIN_GET_SPECIAL_REGIME,
		payload: {
			request: {
				url: `/admin/specialRegimes/${specialRegime.id}`
			}
		}
	};
}

export function adminPostSpecialRegime(specialRegime) {
	return {
		type: API_ADMIN_POST_SPECIAL_REGIME,
		payload: {
			request: {
				url: `/admin/specialRegimes`,
				method: 'POST',
				data: specialRegime
			}
		}
	};
}

export function adminPatchSpecialRegime(specialRegime) {
	return {
		type: API_ADMIN_PATCH_SPECIAL_REGIME,
		payload: {
			request: {
				url: `/admin/specialRegimes/${specialRegime.id}`,
				method: 'PATCH',
				data: specialRegime
			}
		}
	};
}

export function adminDeleteSpecialRegime(specialRegime) {
	return {
		type: API_ADMIN_DELETE_SPECIAL_REGIME,
		payload: {
			request: {
				url: `/admin/specialRegimes/${specialRegime.id}`,
				method: 'DELETE'
			}
		}
	};
}

export function initNewSpecialRegime() {
	return {
		type: ADMIN_INIT_NEW_SPECIAL_REGIME
	};
}

export function resetFocusSpecialRegime() {
	return {
		type: ADMIN_RESET_FOCUS_SPECIAL_REGIME
	};
}
